// These functions are not currently used - keeping for potential future use
function getInitialX({
  isMobile,
  isSerina,
}: {
  isMobile: boolean;
  isSerina: boolean;
}): string {
  if (isMobile) return '0%';
  if (isSerina) return '-100%';
  return '100%';
}

function getAnimateX({
  isExpanded,
  isMobile,
  isSerina,
}: {
  isMobile: boolean;
  isExpanded: boolean;
  isSerina: boolean;
}): string {
  if (isMobile) return '0%';
  if (isExpanded) return '0%';
  if (isSerina) return '-100%';
  return '100%';
}

function getAnimateY({
  isExpanded,
  isMobile,
}: {
  isMobile: boolean;
  isExpanded: boolean;
}): string {
  if (isMobile && isExpanded) return '0%';
  if (isMobile) return '-100%';
  return '0%';
}

export function getAnimationConfiguration({
  isExpanded,
  isMobile,
  isSerina,
}: {
  isMobile: boolean;
  isExpanded: boolean;
  isSerina: boolean;
}) {
  const initialX = getInitialX({ isMobile, isSerina });
  const initialY = '0%';
  const animateX = getAnimateX({ isExpanded, isMobile, isSerina });
  const animateY = getAnimateY({ isExpanded, isMobile });
  const dynamicZIndex = 'z-10';

  return {
    animateX,
    animateY,
    dynamicZIndex,
    initialX,
    initialY,
  };
}
